import { toPx } from 'utils/toPx';

export function getMinHeight(minHeight?: number): React.CSSProperties {
  return minHeight ? { minHeight: toPx(minHeight) } : {};
}
